// extracted by mini-css-extract-plugin
export default {"main":"app-header_main__a3llE","active":"app-header_active__mSjB8","logo":"app-header_logo__NoRyC","account":"app-header_account__Ob2wv"};